<template>
  <svg
    viewBox="0 0 240 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="page-header-illustration"
  >
    <defs>
      <linearGradient
        id="page-card-grad"
        x1="0"
        y1="0"
        x2="240"
        y2="160"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="rgb(10 92 86 / 0.08)" />
        <stop offset="1" stop-color="rgb(217 119 6 / 0.06)" />
      </linearGradient>
      <linearGradient id="page-coin-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stop-color="#0d9488" />
        <stop offset="1" stop-color="#0a5c56" />
      </linearGradient>
    </defs>

    <!-- Background card -->
    <rect
      x="16"
      y="16"
      width="208"
      height="128"
      rx="20"
      fill="url(#page-card-grad)"
      stroke="rgb(10 92 86 / 0.12)"
    />

    <!-- Chart line -->
    <path
      d="M48 120 L88 96 L128 104 L168 72 L208 48"
      stroke="var(--color-primary)"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
      opacity="0.8"
    />
    <circle cx="48" cy="120" r="4" fill="var(--color-primary)" />
    <circle cx="88" cy="96" r="4" fill="var(--color-primary)" />
    <circle cx="128" cy="104" r="4" fill="var(--color-primary)" />
    <circle cx="168" cy="72" r="4" fill="var(--color-primary)" />
    <circle cx="208" cy="48" r="4" fill="var(--color-primary)" />

    <!-- Coin -->
    <circle cx="184" cy="112" r="28" fill="url(#page-coin-grad)" />
    <text
      x="184"
      y="124"
      text-anchor="middle"
      font-family="var(--font-heading)"
      font-weight="700"
      font-size="22"
      fill="white"
    >
      R
    </text>

    <!-- Decorative circles -->
    <circle cx="36" cy="48" r="10" fill="var(--color-accent)" opacity="0.35" />
    <circle cx="220" cy="32" r="8" fill="var(--color-primary-light)" opacity="0.4" />
  </svg>
</template>

<style scoped>
.page-header-illustration {
  width: 100%;
  max-width: 280px;
  height: auto;
}
</style>
